import ApiService from '../api.services';

const URL = '/api/post-office-boxes';

const PostOfficeBoxService = {
    list: async () => (await ApiService.get(URL)).data,
    add: async (form) => (await ApiService.post(URL, { postOfficeBox: form })).data,
    update: async (id, form) => (await ApiService.put(`${URL}/${id}`, { postOfficeBox: form })).data,
    delete: async (id) => (await ApiService.delete(`${URL}/${id}`)).data,
};

export { PostOfficeBoxService };
